import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'layout/atoms/Loader/Loader';
import SubmenuButton from 'layout/atoms/SubmenuButton/SubmenuButton';
import Grid from 'layout/molecules/Grid/Grid';
import { fetchCategories, fetchSuppliers } from 'store/componentsSlice';
import { selectCategoryComponentsAssigned, selectSpecificationComponentsCategory, setCategory, setModalView, } from 'store/specificationComponentsSlice';
import getCategoryLabel from 'utils/getCategoryLabel';
function CategoryItem({ category, name, isActive, onCategoryClick, }) {
    const assignedCount = useSelector(selectCategoryComponentsAssigned(category.id));
    return (React.createElement(SubmenuButton, { text: React.createElement(React.Fragment, null,
            name,
            " ",
            React.createElement("span", null,
                "(",
                category.productsCount,
                ")")), active: isActive, onClick: () => onCategoryClick({
            categorySlug: category.slug,
            filtersAvailable: category.filtersAvailable,
            id: category.id,
            name,
        }), selected: assignedCount }));
}
function CategoriesList() {
    const { i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const categories = useSelector((state) => state.components.categories);
    const selectedCategory = useSelector(selectSpecificationComponentsCategory);
    const categoriesItems = categories.items;
    const categoriesStatus = categories.status;
    useEffect(() => {
        dispatch(fetchCategories());
        dispatch(fetchSuppliers());
    }, [dispatch]);
    useEffect(() => {
        if (categoriesStatus === 'succeeded' && !selectedCategory && categoriesItems.length > 0) {
            const first = categoriesItems[0];
            dispatch(setCategory({
                categorySlug: first.slug,
                filtersAvailable: first.filtersAvailable,
                id: first.id,
                name: getCategoryLabel(first, i18n),
            }));
            dispatch(setModalView('components'));
        }
    }, [categoriesStatus, selectedCategory, categoriesItems, dispatch, i18n]);
    const handleCategoryClick = (category) => {
        dispatch(setCategory(category));
        dispatch(setModalView('components'));
    };
    if (categoriesStatus !== 'succeeded') {
        return React.createElement(Loader, null);
    }
    return (React.createElement(Grid, { gap: 4 }, categoriesItems.map((category) => {
        const name = getCategoryLabel(category, i18n);
        return (React.createElement(CategoryItem, { key: category.id, category: category, name: name, isActive: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) === category.id, onCategoryClick: handleCategoryClick }));
    })));
}
export default memo(CategoriesList);
